import { Component, OnInit,ElementRef, AfterViewInit, ViewChild } from '@angular/core';
import { Http, Headers, Response,RequestOptions} from '@angular/http';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import { AlertService,UserService } from '../_services/index';
declare let $: any;
declare let Ladda:any
import { DatePipe } from '@angular/common';
import { NgForm } from '@angular/forms';
import { environment } from '../../environments/environment';
import { Router, ActivatedRoute,Params} from '@angular/router';

@Component({
  selector: 'app-branchname',
  templateUrl: './branchname.component.html',
  styleUrls: ['./branchname.component.css'],
})

export class BranchNameComponent{
  data:any;
  backendUrl:any;
  sel_id:any;
  loadingnew = false;
  loading = false;
  complexForm:FormGroup;
  model: any = {};
  id:number;

constructor(fb: FormBuilder,private http: Http,private datePipe: DatePipe,private userService:UserService,private router: Router,private activatedRoute: ActivatedRoute) {
    this.complexForm = fb.group({
      // To add a validator, we must first convert the string value into an array. The first item in the array is the default value if any, then the next item in the array is the validator. Here we are adding a required validator meaning that the firstName attribute must have a value in it.

      // We can use more than one validator per field. If we want to use more than one validator we have to wrap our array of validators with a Validators.compose function. Here we are using a required, minimum length and maximum length validator.

    })

  }
  ngOnInit(){

	let url=window.location.hostname;
    // if(url=='app.foodbot.ai' || url=='dashboard.foodbot.ai'){this.backendUrl=environment.prod}
    // else if(url=='stage.foodbot.ai'){ this.backendUrl=environment.stage}
    // else if(url=='uat.foodbot.ai'){ this.backendUrl=environment.uat}
    // else{ this.backendUrl=environment.local}
    if (url == 'app.foodbot.ai' || url == 'dashboard.foodbot.ai') { this.backendUrl = environment.prod } else if (url == 'stage.foodbot.ai') { this.backendUrl = environment.stage } 
    else if (url == 'uat.foodbot.ai') { this.backendUrl = environment.uat } 
    else if (url == '127.0.0.1') { this.backendUrl = environment.local } 
    else { 
      this.backendUrl=window.location.origin
      this.backendUrl+="/apis"
    }

    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
     let restaurant_id=currentUser.restaurant_id;
     let sql="SELECT * FROM fb_branches where restaurant_id="+restaurant_id+" order by branch_id asc" 
     let headers = new Headers ({  'Content-Type': 'application/json' });
     let options = new RequestOptions({ headers: headers, method: "post" });

      this.userService.getdata(this.backendUrl,JSON.stringify({'query': sql}))
            .subscribe(data => {
            this.id = data[0].branch_id;
          	this.model.branch_name = data[0].branch_name;
            this.model.branch_aliases = data[0].branch_aliases;
          console.log("I CAN SEE DATA HERE: ", this.data);
        });


$(document).ready(function(){

$.validator.addMethod("clsRequired", function(value, element) { 
  return value == '' || value.trim().length != 0; 
}, "This Field is required");

	 $('#branch_aliases').validate({
        rules:{
          branch_name:{required:true},

        },
        messages:{
          branch_name:{required:"This Field is required"},

        },
        errorPlacement: function(error, element) {
          if (element.type == 'checkbox') {
            error.appendTo(element.parent());
          }
          else {
            error.insertAfter(element);
          }
        }

      })

   });
  }

  save_aliases()
  {
    let dayData = '';
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let restaurant_id=currentUser.restaurant_id;
    if($('#branch_aliases').valid())
    {
      var l = Ladda.create( document.querySelector( '#save_aliases' ) );
      l.start();
      let userdata = {
        branch_name : this.model.branch_name,
        branch_aliases : this.model.branch_aliases,
        restaurant_id : restaurant_id

      };

      if(this.id){
        let sql="update fb_branches set ? where branch_id="+this.id;
        this.userService.insert(this.backendUrl,JSON.stringify({'query': sql,'data':userdata}))
          .subscribe(data => {
            l.stop();
            this.ngOnInit();
                $('#success').html('Your branch is updated successfully');
                   $('#success').show();
                   setTimeout(function(){
                           $('#success').hide();
                    },3000);
          });
      }
      else{
        let sql="insert into fb_branches SET ?"
        this.userService.insert(this.backendUrl,({'query': sql,'data':userdata}))
          .subscribe(data => {
            this.id = data.id;
            l.stop();
            this.ngOnInit();
                $('#success').html('Your branch  is save successfully');
                   $('#success').show();
                   setTimeout(function(){
                           $('#success').hide();
                    },3000);
          });
      }

    }
  }
}



// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/branchname/branchname.component.ts